module.exports = __webpack_public_path__ + "static/sprobg.1ad90d2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sprobg.jpg
// module id = 3214
// module chunks = 129519670211406